import RL from './route-literals';

export default {
  root: RL.root,
  signIn: `/${RL.signIn}`,
  termsConditions: `/${RL.termsConditions}`,
  privacyPolicy: `/${RL.privacyPolicy}`,
};
